import { ShearForceTypeDTO, ShearForceTypeDTOFireProtectionTypeEnum } from '~/api/webservice';
import { IProductProperties, ISOPROProduct } from '~/models';
import { useProductsStore } from '~/store';

/** */
export class ISOPROProductShearForceType extends ISOPROProduct {
  declare readonly type: ShearForceTypeDTO["type"];
  declare readonly height: ShearForceTypeDTO["height"];
  declare readonly fireProtectionType: ShearForceTypeDTO["fireProtectionType"];
  declare readonly capacity: ShearForceTypeDTO["capacity"];

  declare readonly properties: {
    dimensions: IProductProperties["dimensions"];
    construction: {
      thrustBearings: IProductProperties["construction"]["thrustBearings"] & {
        numberOfThrustShearPosBearing: ShearForceTypeDTO["numberOfThrustShearPosBearing"];
        numberOfThrustShearNegBearing: ShearForceTypeDTO["numberOfThrustShearNegBearing"];
        diameterOfThrustShearPosBearing: ShearForceTypeDTO["diameterOfThrustShearPosBearing"];
        diameterOfThrustShearNegBearing: ShearForceTypeDTO["diameterOfThrustShearNegBearing"];
        kindOfThrustBearing: ShearForceTypeDTO["kindOfThrustBearing"];
      };
      tensionRods: IProductProperties["construction"]["tensionRods"];
    };
  }

  constructor (data: ShearForceTypeDTO) {
    super(data);

    this.type = data.type;
    this.height = data.height;
    this.capacity = data.capacity;

    this.properties = {
      ...this.properties,
      construction: {
        ...this.properties.construction,
        thrustBearings: {
          ...this.properties.construction.thrustBearings,
          numberOfThrustShearNegBearing: data.numberOfThrustShearNegBearing,
          numberOfThrustShearPosBearing: data.numberOfThrustShearPosBearing,
          diameterOfThrustShearNegBearing: data.diameterOfThrustShearNegBearing,
          diameterOfThrustShearPosBearing: data.diameterOfThrustShearPosBearing,
          kindOfThrustBearing: data.kindOfThrustBearing
        }
      }
    }
  }

  getOneWithoutFireProtection (): ISOPROProductShearForceType | null {
    if (this.hasFireProtection) return null;
    const rowKey = `${this.rowKey} ${ShearForceTypeDTOFireProtectionTypeEnum.Rei120}`;
    return (useProductsStore().productsMap.get(rowKey) as ISOPROProductShearForceType) || null;
  }
}
